var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"动态审核开启关闭","name":"DynamicAudit"}},[_c('DynamicAudit')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }